import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/compound-daily-interest',
  component: () => import('../../routes/CompoundDaily.svelte'),
  card: {
    id: 'compound-daily-interest',
    title: 'Compound Daily Interest',
    description: 'Calculate compound interest with daily or any custom compounding frequency. See your money grow day by day.',
    icon: 'calendar_month',
    iconBgClass: 'bg-blue-50',
    iconTextClass: 'text-blue-600',
    href: '/compound-daily-interest',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Compound Daily Interest Calculator – Free Daily Compound Calculator',
    description: 'Free compound daily interest calculator. Calculate compound interest with daily, monthly, quarterly, or annual compounding. See year-by-year growth breakdown.',
  },
};

export default meta;
